import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { getErrorMessage } from '../../../../helper/validation.helper';
import { ContractGroupTypeEntity } from '../../../../dave-data-module/entities/mdqx/contract-group-type.entity';
import { ContractStatusEntity } from '../../../../dave-data-module/entities/mdqx/contract-status.entity';
import { PostContractRequest } from '../../../../dave-data-module/State/actions/mdqx/contract.actions';
import { PostContractOptionsRequest } from '../../../../dave-data-module/State/actions/mdqx/contract-options.actions';
import {
    getContractGroupType,
    getContractOptions,
    getContracts,
    getContractStatus,
    getTEGueltigkeiten,
} from '../../../../dave-data-module/State/selectors/mdqx/selectors';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { RoutingHistoryService } from '../../../../dave-utils-module/dave-shared-components-module/services/routing-history.service';
import { skip, take } from 'rxjs/operators';
import { TEGueltigkeitEntity } from '../../../../dave-data-module/entities/mdqx/te-gueltigkeit.entity';
import { State } from '../../../../dave-data-module/State';
import { TEGueltigkeitDauerUnits } from '../../../../dave-data-module/entities/mdqx/contract-options.entity';

@Component({
    selector: 'app-new-contract',
    templateUrl: './new-contract.component.html',
    styleUrls: ['./new-contract.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewContractComponent implements OnInit {
    public GetErrorMessage = getErrorMessage;
    public TEGueltigkeitDauerUnits = TEGueltigkeitDauerUnits;
    public ContractForm: FormGroup = new FormGroup({
        Name: new FormControl('', Validators.required),
        Number: new FormControl('', Validators.required),
        VertragsNummer: new FormControl(''),
        ContractSign: new FormControl(''),
        ContractGroupType: new FormControl(''),
        Description: new FormControl(''),
        StartDate: new FormControl(''),
        EndDate: new FormControl(''),
        ContractStatus: new FormControl(''),
        Abrechnungszyklus: new FormControl(''),
        DTAOptions: new FormControl(''),
        TeGueltigkeitDauerUnit: new FormControl(''),
        TeGueltigkeitDauerValue: new FormControl('', Validators.pattern(/^[0-9]+$/)),
        Casenumber: new FormControl('', Validators.pattern(/^[0-9]+$/)),
        HatAnamnese: new FormControl(false),
        IstWKV: new FormControl(false),
        WiderrufsfristInTagen: new FormControl(0, Validators.pattern(/^[0-9]+$/)),
        KuendigungsfristInTagen: new FormControl(0, Validators.pattern(/^[0-9]+$/)),
        LaufzeitInMonaten: new FormControl('', Validators.pattern(/^[0-9]+$/)),
        EinreichfristNachQuartalEndeInWochen: new FormControl(12),
        MindestalterVersicherter: new FormControl(0, Validators.pattern(/^[0-9]+$/)),
        TEGueltigkeit: new FormControl(),
        TEAnzahlSeiten: new FormControl(2, Validators.pattern(/^[0-9]+$/)),
        SachkontoDebitor: new FormControl(),
        SachkontoKreditor: new FormControl(),
        MedizinprodukteEigenleistungErlaubt: new FormControl(false),
        HatDiagnostik: new FormControl(false),
    }) as FormGroupTyped<{
        Name: string | null,
        Number: string | null;
        VerrtragsNummer: string | null;
        ContractSign: string | null;
        ContractGroupType: string | null;
        Description: string | null;
        StartDate: string | null;
        EndDate: string | null;
        ContractStatus: ContractStatusEntity | null;
        Abrechnungszyklus: string | null;
        DTAOptions: string | null;
        TeGueltigkeitDauerUnit: string | null,
        TeGueltigkeitDauerValue: number | null,
        Casenumber: number | null;
        HatAnamnese: boolean;
        IstWKV: boolean;
        WiderrufsfristInTagen: number | null;
        KuendigungsfristInTagen: number | null;
        LaufzeitInMonaten: number | null;
        EinreichfristNachQuartalEndeInWochen: string | null;
        MindestalterVersicherter: number | null;
        TEGueltigkeit: string | null;
        TEAnzahlSeiten: number | null;
        SachkontoDebitor: string | null;
        SachkontoKreditor: string | null;
        MedizinprodukteEigenleistungErlaubt: boolean;
        HatDiagnostik: boolean;
    }>;

    public ContractGroupTypeList: Observable<ContractGroupTypeEntity[]>;
    public ContractStatusList: Observable<ContractStatusEntity[]>;
    public TEGueltigkeitList: Observable<TEGueltigkeitEntity[]>;
    private defaultContractStatusId = 3;

    constructor(
        private store: Store<State>,
        private routingHistoryService: RoutingHistoryService,
        private router: Router) {
        this.ContractGroupTypeList = this.store.select(getContractGroupType);
        this.ContractStatusList = this.store.select(getContractStatus);
        this.TEGueltigkeitList = this.store.select(getTEGueltigkeiten);
    }

    public OnStartDateChange(date: Date) {
        this.StartDate.setValue(date);
    }

    public OnEndDateChange(date: Date) {
        this.EndDate.setValue(date);
    }

    ngOnInit(): void {
        this.ContractStatusList.subscribe(list => list.forEach(el => {
            if (el.Id === this.defaultContractStatusId) {
                this.ContractStatus.setValue(el);
                console.log(el);
            }
        }));
    }


    public Submit() {
        const {
            Name,
            Number,
            VertragsNummer,
            ContractSign,
            ContractGroupType,
            Description,
            StartDate,
            EndDate,
            ContractStatus,
            Abrechnungszyklus,
            DTAOptions,
            TeGueltigkeitDauerUnit,
            TeGueltigkeitDauerValue,
            Casenumber,
            HatAnamnese,
            IstWKV,
            WiderrufsfristInTagen,
            KuendigungsfristInTagen,
            LaufzeitInMonaten,
            EinreichfristNachQuartalEndeInWochen,
            MindestalterVersicherter,
            TEGueltigkeit,
            TEAnzahlSeiten,
            SachkontoDebitor,
            SachkontoKreditor,
            MedizinprodukteEigenleistungErlaubt,
            hatDiagnostik,
        } = this.ContractForm.value;

        this.store.dispatch(new PostContractRequest({
            name: Name,
            number: Number,
            vertragsNummer: VertragsNummer,
            contractGroupTypeId: ContractGroupType[0]?.Id || null,
            contractSign: ContractSign,
            contractStatusId: ContractStatus.Id,
            sachkontoDebitor: SachkontoDebitor,
            sachkontoKreditor: SachkontoKreditor,
            abrechnungszyklus: Abrechnungszyklus,
            description: Description,
            endDate: EndDate,
            startDate: StartDate,
            hatDiagnostik
        }));
        this.store.select(getContracts).pipe(
            skip(1),
            take(1)
        ).subscribe(contracts => {
            const contract = contracts[contracts.length - 1];
            this.store.dispatch(new PostContractOptionsRequest({
                contractId: contract.Id,
                dtaOptions: DTAOptions,
                teGueltigkeitDauerUnit: TeGueltigkeitDauerUnit,
                teGueltigkeitDauerValue: +TeGueltigkeitDauerValue,
                casenumber: Casenumber,
                hatAnamnese: HatAnamnese,
                istWkv: IstWKV,
                kuendigungsfristInTagen: +KuendigungsfristInTagen,
                einreichfristNachQuartalEndeInWochen: +EinreichfristNachQuartalEndeInWochen,
                laufzeitInMonaten: +LaufzeitInMonaten,
                medizinprodukteEigenleistungErlaubt: MedizinprodukteEigenleistungErlaubt,
                mindestalterVersicherter: +MindestalterVersicherter,
                teAnzahlSeiten: +TEAnzahlSeiten,
                widerrufsfristInTagen: +WiderrufsfristInTagen,
                teGueltigkeitId: TEGueltigkeit?.Id
            }));
            this.store.select(getContractOptions).pipe(
                skip(1),
                take(1)
            ).subscribe(contractOptions => {
                this.router.navigate(['/vertraege', contract.Id]);
            });
        });
    }

    public Cancel() {
        this.routingHistoryService.NavigateBackwards();
    }

    public MapContractGroupType(option: ContractGroupTypeEntity) {
        return option.Name;
    }

    get Name() {
        return this.ContractForm.get('Name');
    }

    get Number() {
        return this.ContractForm.get('Number');
    }
    get VertragsNummer() {
        return this.ContractForm.get('VertragsNummer');
    }

    get ContractSign() {
        return this.ContractForm.get('ContractSign');
    }

    get ContractGroupType() {
        return this.ContractForm.get('ContractGroupType');
    }

    get Description() {
        return this.ContractForm.get('Description');
    }

    get StartDate() {
        return this.ContractForm.get('StartDate');
    }

    get EndDate() {
        return this.ContractForm.get('EndDate');
    }

    get ContractStatus() {
        return this.ContractForm.get('ContractStatus');
    }

    get Abrechnungszyklus() {
        return this.ContractForm.get('Abrechnungszyklus');
    }

    get DTAOptions() {
        return this.ContractForm.get('DTAOptions');
    }

    get TeGueltigkeitDauerUnit() {
        return this.ContractForm.get('TeGueltigkeitDauerUnit');
    }

    get TeGueltigkeitDauerValue() {
        return this.ContractForm.get('TeGueltigkeitDauerValue');
    }

    get Casenumber() {
        return this.ContractForm.get('Casenumber');
    }

    get HatAnamnese() {
        return this.ContractForm.get('HatAnamnese');
    }

    get IstWKV() {
        return this.ContractForm.get('IstWKV');
    }

    get WiderrufsfristInTagen() {
        return this.ContractForm.get('WiderrufsfristInTagen');
    }

    get KuendigungsfristInTagen() {
        return this.ContractForm.get('KuendigungsfristInTagen');
    }

    get LaufzeitInMonaten() {
        return this.ContractForm.get('LaufzeitInMonaten');
    }

    get EinreichfristNachQuartalEndeInWochen() {
        return this.ContractForm.get('EinreichfristNachQuartalEndeInWochen');
    }

    get MindestalterVersicherter() {
        return this.ContractForm.get('MindestalterVersicherter');
    }

    get TEGueltigkeit() {
        return this.ContractForm.get('TEGueltigkeit');
    }

    get TEAnzahlSeiten() {
        return this.ContractForm.get('TEAnzahlSeiten');
    }

    get SachkontoDebitor() {
        return this.ContractForm.get('SachkontoDebitor');
    }

    get SachkontoKreditor() {
        return this.ContractForm.get('SachkontoKreditor');
    }


    get MedizinprodukteEigenleistungErlaubt() {
        return this.ContractForm.get('MedizinprodukteEigenleistungErlaubt');
    }
}
